// Obtém a localização do cliente
function getGeoLocation(cb = null) {
  let geoIp = null;
  if (sessionStorage.getItem('geoip')) {
    geoIp = JSON.parse(sessionStorage.getItem('geoip'));
    if (cb !== null) {
      cb(geoIp);
      return false;
    }
  } else {
    $.getJSON(`${urlBase}core/acoes/utils/geo.php?store_slug=${baseStore}`, function (result) {
      if (result.status === 'success') {
        sessionStorage.setItem('geoip', JSON.stringify(result));
        if (cb !== null) {
          cb(result);
          return false;
        }
      } else {
        sessionStorage.removeItem('geoip');
        if (cb !== null) {
          cb(false);
        }
      }
    });
  }
}

// Substituição de variáveis nas páginas
(function () {
  'use strict';

  // Variáveis a substituir
  const replacesVars = window.LPQV_VARS_RPL || {};
  replacesVars['{{cidade}}'] = '';
  replacesVars['{{uf}}'] = '';
  replacesVars['{{estado}}'] = '';
  replacesVars['{{pais}}'] = '';
  replacesVars['{{pais-sigla}}'] = '';
  replacesVars['{{hoje}}'] = formataDataExt(new Date(), '{d}/{m}/{Y}');
  replacesVars['{{hoje-ext}}'] = getCurDateExt();
  replacesVars['{{amanha}}'] = formataDataExt(addDays(new Date(), 1), '{d}/{m}/{Y}');
  replacesVars['{{amanha-ext}}'] = getCurDateExt(addDays(new Date(), 1));
  replacesVars['{{ano}}'] = formataDataExt(new Date(), '{Y}');
  replacesVars['{{ano-ab}}'] = formataDataExt(new Date(), '{y}');
  replacesVars['{{mes}}'] = formataDataExt(new Date(), '{m}');
  replacesVars['{{mes-ext}}'] = formataDataExt(new Date(), '{F}');
  replacesVars['{{dia}}'] = formataDataExt(new Date(), '{d}');
  replacesVars['{{dia-semana}}'] = formataDataExt(new Date(), '{l}');
  replacesVars['{{dia-semana-ab}}'] = formataDataExt(new Date(), '{D}');
  replacesVars['{{horario}}'] = formataDataExt(new Date(), '{H}:{i}');
  replacesVars['{{hora}}'] = formataDataExt(new Date(), '{H}');
  replacesVars['{{minuto}}'] = formataDataExt(new Date(), '{i}');
  replacesVars['{{rand-1-10}}'] = randomNumber(1, 10);
  replacesVars['{{rand-10-100}}'] = randomNumber(10, 100);
  replacesVars['{{rand-100-1000}}'] = randomNumber(100, 1000);
  replacesVars['{{rand-1000-10000}}'] = randomNumber(1000, 10000);

  // Encontra os elementos com o padrão
  const elsReplace = [];

  function initReplaceVars() {
    let selectorEl = [];
    Object.keys(replacesVars).forEach(function (rplVar) {
      selectorEl.push(":contains('" + rplVar + "')");
    });
    selectorEl = selectorEl.join(',');
    $(selectorEl).each(function () {
      const textNodes = $(this)
        .contents()
        .filter(function () {
          if (this.nodeType === 3) {
            for (let varVerify of Object.keys(replacesVars)) {
              if (this.nodeValue.indexOf(varVerify) !== -1) {
                return true;
              }
            }
          }
        });
      const elParent = textNodes.parent();
      if (elParent[0] && !elsReplace.includes(elParent[0])) {
        elsReplace.push(elParent[0]);
      }
    });
    if (elsReplace.length > 0) {
      loadingReplaces();
      getGeoLocation(function (geoIp) {
        if (geoIp) {
          replacesVars['{{cidade}}'] = geoIp?.city || '';
          replacesVars['{{uf}}'] = geoIp?.region || '';
          replacesVars['{{estado}}'] = geoIp?.regionName || '';
          replacesVars['{{pais}}'] = geoIp?.country || '';
          replacesVars['{{pais-sigla}}'] = geoIp?.countryCode || '';
        }
        showReplaces();
      });
    }
  }
  initReplaceVars();
  $('body').on('replace-vars', initReplaceVars);

  // Oculta os elementos enquanto os dados são carregados
  function loadingReplaces() {
    elsReplace.forEach(function (el) {
      el.style.opacity = '0';
    });
  }

  // Substitui as variáveis
  function showReplaces() {
    elsReplace.forEach(function (el) {
      let elText = el.innerHTML;
      let elNewText = elText;
      Object.keys(replacesVars).forEach(function (rK) {
        if (replacesVars[rK]) {
          const regexRpl = new RegExp('\\' + rK + '', 'g');
          elNewText = elNewText.replace(regexRpl, replacesVars[rK]);
        }
      });
      el.innerHTML = elNewText;
      el.style.opacity = '1';
    });
  }
})();
